import type { Marque, Produit } from "@/data/catalog";

export type View =
  | { nom: "accueil" }
  | { nom: "marques" }
  | { nom: "marque"; slug: string }
  | { nom: "packs" }
  | { nom: "portails" }
  | { nom: "signature" }
  | { nom: "site"; slug: string };

export interface PanierItem {
  id: string;
  nom: string;
  marque: string;
  image: string;
  prix: number;
  qte: number;
}

/** Prix de démonstration déterministe, élégant (toujours « ,90 ») */
export function prixProduit(num: number): number {
  return 3.9 + ((num * 37) % 46);
}

export function formatPrix(p: number): string {
  return p.toFixed(2).replace(".", ",") + " €";
}

export function cleProduit(m: Marque, p: Produit): string {
  return m.slug + "/" + p.num;
}
